import { useForm } from "react-hook-form";

const ContactForm = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => console.log(data);
  return (
    <form id="contact-form" onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-md-6">
          <div className="single-form">
            <input
              type="text"
              name="name"
              placeholder="Enter your name..."
              // ref={register({ required: "Name is required" })}
              {...register("firstName", { required: true })}
            />
            {errors.firstName?.type === "required" && (
              <p role="alert">First name is required</p>
            )}
          </div>
        </div>
        <div className="col-md-6">
          <div className="single-form">
            <input
              type="email"
              name="email"
              placeholder="yourmail@domain.com"
              {...register("mail", { required: "Email Address is required" })}
              aria-invalid={errors.mail ? "true" : "false"}
            />
            {errors.mail && <p role="alert">{errors.mail.message}</p>}
          </div>
        </div>
        <div className="col-md-12">
          <div className="single-form">
            <textarea
              name="message"
              placeholder="Here goes your message"
              // ref={register({
              //     required: "Message is required",
              // })}
              {...register("message", { required: "Message is required" })}
              aria-invalid={errors.message ? "true" : "false"}
            ></textarea>
            {errors.message && <p role="alert">{errors.message.message}</p>}
          </div>
        </div>
        <p className="form-message"></p>
        <div className="col-md-12">
          <div className="form-btn">
            <button type="submit">Send Message</button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default ContactForm;
